import { ConditionalFeature, Feature, Features, MaybeConditionalFeature } from '@sona/shared-model-common';

/**
 * Checks if a feature is available based on the specified condition.
 */
export const checkPermission = <F extends Feature>(availableFeatures: Features, feature: MaybeConditionalFeature<F>): boolean => {
    if (typeof feature === 'string') {
        return !!availableFeatures[feature];
    }

    // If it's a conditional feature, check the condition
    const { key, condition } = feature as ConditionalFeature<F>;
    const options = availableFeatures[key];

    if (!options) {
        return false;
    }

    // @ts-ignore -- can't properly type this, but we know options matches the expected type
    return condition(options);
};
